import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useLeftBar } from "../../context/LeftBar";
import NavItem from "./MenuItem/NavItem";
import { styled } from "@mui/material/styles";
import { IconButton } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Card from "../../components/Cards/Card";
import { Grid } from "@mui/material";

import DashboardIcon from "@mui/icons-material/Dashboard";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import ContactSupportOutlinedIcon from "@mui/icons-material/ContactSupportOutlined";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

import { ReactComponent as IconPositivacao } from "../../assets/icons/sideMenu/iconpositivacao.svg";
import { ReactComponent as IconInsights } from "../../assets/icons/sideMenu/iconInsights.svg";
import { ReactComponent as WhereToSellWhite } from "../../assets/icons/whereToSellWhite.svg";
import { ReactComponent as WhereToSellBlue } from "../../assets/icons/whereToSellWhiteBlue.svg";
import { ReactComponent as AvatarIcon} from "../../assets/icons/avatar.svg"

import styles from "../LeftSideMenu/styles.css";

import {
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

const StyledSidebar = styled("div")(({ theme, isOpen }) => ({
  width: 280,
  backgroundColor: "#fff",
  height: "calc(100vh - 64px)",
  position: "fixed",
  left: 0,
  top: 64,
  zIndex: 1,
  borderRight: "1px solid #eee",
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  "&.collapsed": {
    width: 65,
    paddingRight: 0,
    "& .navItem": {
      width: "40px",
      margin: "2px auto",
      "& a": {
        justifyContent: "center",
        padding: 0,
      },
      "& a:hover": {
        borderRadius: "8px",
      },
    },
    "& .leftSideHeader": {
      justifyContent: "center",
      padding: 0,
      "& .MuiButtonBase-root": {
        margin: "8px 0",
      },
    },
    "& .leftSideContentTitle": {
      padding: "16px 0",
      margin: "0 auto",
      width: "32px",
      borderTop: "1px solid #eee",
      fontSize: 0,
    },
    "& .navItemNameContainer": {
      justifyContent: "center",
      padding: "8px 0",
      width: "32px",
      margin: "0 auto",
      "& svg": {
        width: 20,
        height: 20,
      },
    },
    "& a.active": {
      backgroundColor: "#1E276D",
      borderRadius: "8px",
      width: "40px",
      marginRight: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& svg": {
        position: "relative",
        zIndex: 1,
        color: "#fff",
      },
    },
    "& .navItemName": {
      display: "none",
    },
    "& .MuiListItemText-root": {
      opacity: 0,
      width: 0,
      padding: 0,
      margin: 0,
    },
  },
  "& .leftSideHeader": {
    display: "flex",
    justifyContent: "flex-end",
    padding: "0 8px",
    "& .MuiButtonBase-root": {
      padding: 8,
      margin: "8px 0",
    },
  },
  "& .leftSideContent": {
    "& ul": {
      padding: 0,
      margin: 0,
    },
  },
  "& .leftSideContentTitle": {
    fontSize: "11px",
    color: "#666",
    padding: "24px 24px 8px",
    margin: 0,
  },
  "& .navItemNameContainer": {
    padding: "8px 0",
    display: "flex",
    alignItems: "center",
    "& svg": {
      width: 18,
      height: 18,
      color: "#666",
      marginRight: isOpen ? "12px" : 0,
    },
  },
  "& a": {
    textDecoration: "none",
    color: "#333",
    display: "block",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
    "&.active": {
      backgroundColor: "#00843D",
      color: "#fff",
      borderRadius: "0 8px 8px 0",
      "& svg": {
        color: "#fff",
      },
    },
  },
  "& .navItem": {
    width: "94%",
    "& a": {
      justifyContent: "flex-start",
      paddingLeft: "24px",
    },
    "& a:hover": {
      borderRadius: "0 8px 8px 0",
    },
  },
  "& .MuiListItemIcon-root": {
    minWidth: "auto",
    justifyContent: "center",
    // marginRight: isOpen ? "12px" : "0",
    // padding: 0,
    display: "flex",
    alignItems: "center",
    "& svg": {
      width: 18,
      height: 18
    }
  },
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

const OBJECT_IDS = {
  USER_NAME: "mxjGX",
};

const WelcomeCard = ({ nameUser, isOpen }) => {
  return (
    <Card className="container-card-footer">
      <Grid container spacing={1} >
        <Grid item>
          <AvatarIcon />
        </Grid>
        <Grid item>
        <p className={`user-name ${!isOpen ? 'is-hidden' : ''}`}>{nameUser}</p>
        </Grid>
      </Grid>
    </Card>
  );
};

function LeftSideMenu({ app, config, logo }) {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [dataAtualizacao, setDataAtualizacao] = useState("");
  const { leftBarOpened, setLeftBarOpened } = useLeftBar();
  const [open, setOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState("Resultados");
  const [activeItem, setActiveItem] = useState("Resultados");
  const [nameUser, setNameUser] = useState("");
  const [openResultados, setOpenResultados] = useState(true);

  const getNameUser = useCallback(
    async (objectId) => {
      if (app && objectId) {
        try {
          const res = await app.visualization.get(objectId);
          const value = res?.model?.layout?.style?.label;
          setNameUser(value);
        } catch (error) {
          console.error("Erro ao buscar nome do usuário:", error);
        }
      }
    },
    [app]
  );

  useEffect(() => {
    if (app) {
      getNameUser(OBJECT_IDS.USER_NAME);
    }
  }, [app, getNameUser]);

  const handleClick = () => {
    setOpen(!open);
    if (!open) {
      setOpenMenu("ondeVender");
      setActiveItem("ondeVender");
    } else {
      setOpenMenu("Resultados");
      setActiveItem("Resultados");
    }
  };;

  if (!app || !config) {
    return null;
  }

  return (
    <StyledSidebar
      className={`leftSideMenu ${!leftBarOpened ? "collapsed" : "is-opened"}`}
      isOpen={leftBarOpened}
    >
      <div className="leftSideHeader">
        <IconButton onClick={() => setLeftBarOpened(!leftBarOpened)}>
          {leftBarOpened ? <ChevronLeftIcon /> : <ChevronRightIcon />}
        </IconButton>
      </div>
      <div className="leftSideContent">
        <ul>
          <ListItemButton
            onClick={() => setOpenResultados(!openResultados)}
            style={{
              backgroundColor: openResultados ? "#1E276D" : "transparent",
              borderTopRightRadius: openResultados ? "12px" : "0",
              borderBottomRightRadius: openResultados ? "12px" : "0",
              color: openResultados ? "#fff" : "inherit",
              gap: "22px",
            }}
          >
            <ListItemIcon sx={{ marginLeft: "6px" }}>
              <DashboardIcon sx={{ color: openResultados ? "#fff" : "#000B72" }} />
            </ListItemIcon>
            <ListItemText
              primary="Resultados"
              sx={{
                "& .MuiTypography-root": {
                  fontWeight: 400,
                  fontSize: "14px",
                  fontFamily: "lato",
                  color: openResultados ? "#fff" : "#000B72",
                  whiteSpace: "nowrap",
                },
              }}
            />
          </ListItemButton>
          <Collapse in={openResultados} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <NavItem
                name="Alimentar"
                path="/overview?segment=alimentar"
                customClass="spaced-nav"
              />
              <NavItem
                name="Farma"
                path="/overview?segment=farma"
                customClass="spaced-nav"
              />
            </List>
          </Collapse>
        </ul>
        <ul>
          <ListItemButton
            onClick={handleClick}
            style={{
              backgroundColor: open ? "#1E276D" : "transparent",
              borderTopRightRadius: open ? "12px" : "0",
              borderBottomRightRadius: open ? "12px" : "0",
              color: open ? "#fff" : "inherit",
              gap: "22px",
            }}
            className={` ${openMenu === "active" ? "resultados" : ""}`}
          >
            <ListItemIcon sx={{marginLeft: "6px"}}>
              {open ? <WhereToSellWhite /> : <WhereToSellBlue />}
            </ListItemIcon>
            <ListItemText
              primary="Onde Vender"
              sx={{
                "& .MuiTypography-root": {
                  fontWeight: 400,
                  fontSize: "14px",
                  fontFamily: "lato",
                  color: open ? "#fff" : "#000B72",
                  whiteSpace: "nowrap",
                },
              }}
            />
            {leftBarOpened && (open ? <ExpandLess /> : <ExpandMore />)}
          </ListItemButton>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <NavItem
                name="Nivea Trim. Móvel"
                path="/base-covarage"
                customClass="spaced-nav"
              />
              <NavItem
                name="Skin Care"
                path="/pc-skin"
                customClass="spaced-nav"
              />
              <NavItem
                name="(BodyHand) + (F P)"
                path="/bodyhand-facialpotinhos"
                customClass="spaced-nav"
              />
              <NavItem
                name="Via E-Commerce"
                path="/digital-channels"
                customClass="spaced-nav"
              />
              <NavItem
                name="Pontos Top 10"
                path="/points-top-10"
                customClass="spaced-nav"
              />
              <NavItem
                name="Sell Thru NIVEA"
                path="/sellout-nivea"
                customClass="spaced-nav"
              />
              <NavItem
                name="Sell Thru Eucerin"
                path="/sellout-eucerin"
                customClass="spaced-nav"
              />
            </List>
          </Collapse>
        </ul>

        <h3 className="leftSideContentTitle">AJUDA</h3>
        <ul>
          <NavItem
            muiIcon={<DescriptionOutlinedIcon />}
            name="Regras da Campanha"
            path="/roles"
          />
        </ul>
        <ul>
          <NavItem
            muiIcon={<ContactSupportOutlinedIcon />}
            name="Perguntas Frequentes"
            path="/faq"
          />
        </ul>
        <div className="leftSideContentFooter">
          <hr className="divider"></hr>
          <h3 className="leftSideContentTitle">NIVEA</h3>
          <WelcomeCard nameUser={nameUser} isOpen={leftBarOpened} />
        </div>
      </div>
    </StyledSidebar>
  );
}

LeftSideMenu.defaultProps = {
  app: null,
  config: null,
  logo: null,
};

LeftSideMenu.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
  logo: PropTypes.object,
};

WelcomeCard.propTypes = {
  nameUser: PropTypes.string.isRequired,
};

export default LeftSideMenu;
